import React from "react";
import "./HTML_MAIN_CSS.css";

const HTML_StudyPlan = () => {
  const plan = [
    {
      day: "Day 1",
      topics: [
        "Introduction to HTML",
        "HTML History and Evolution",
        "HTML vs XHTML",
        "HTML Editors and Tools",
      ],
      exercises: ["Set up your first HTML file", "Write a simple 'Hello World' page"],
    },
    {
      day: "Day 2",
      topics: [
        "HTML Document Structure",
        "Doctype declaration",
        "Head & Body sections",
        "Title, Meta, Charset",
      ],
      exercises: ["Create an HTML page with proper head and body", "Add title and meta description"],
    },
    {
      day: "Day 3",
      topics: [
        "Text Formatting: Headings, Paragraphs, Line Breaks",
        "Bold, Italic, Underline, Strikethrough",
        "Superscript & Subscript",
        "Semantic Text Elements: <strong>, <em>, <mark>, <small>, <abbr>",
      ],
      exercises: ["Format a paragraph with different styles", "Use semantic elements to highlight importance"],
    },
    {
      day: "Day 4",
      topics: [
        "HTML Links: Hyperlinks, Anchors, Bookmarks",
        "Link Colors and Styling",
        "Opening links in new tab",
      ],
      exercises: ["Create navigation menu with links", "Create internal page anchors"],
    },
    {
      day: "Day 5",
      topics: [
        "HTML Images: <img> tag, alt, width, height",
        "Image Maps",
        "Background Images",
        "Picture element",
      ],
      exercises: ["Add multiple images to a page", "Create an image map", "Use responsive picture element"],
    },
    {
      day: "Day 6",
      topics: [
        "HTML Tables: Create tables, Headers, Rows & Cells",
        "Colspan & Rowspan",
        "Table Styling, Padding & Spacing",
        "Table Borders, Size and Alignment",
      ],
      exercises: ["Create a timetable or product list table", "Style the table with CSS"],
    },
    {
      day: "Day 7",
      topics: [
        "HTML Lists: Ordered, Unordered, Definition Lists",
        "Nested Lists",
      ],
      exercises: ["Create a nested list for website menu or recipe steps"],
    },
    {
      day: "Day 8",
      topics: [
        "HTML Forms: Form Elements, Input Types & Attributes",
        "Textarea, Select, Radio, Checkboxes, Buttons",
        "Form Validation Basics",
      ],
      exercises: ["Create a registration form with validation", "Add a submit button"],
    },
    {
      day: "Day 9",
      topics: [
        "HTML Multimedia: Audio, Video, YouTube Embed",
        "Plug-ins and Objects",
      ],
      exercises: ["Embed a video and audio player", "Add a YouTube video iframe"],
    },
    {
      day: "Day 10",
      topics: [
        "HTML Graphics: Canvas, SVG",
        "Drawing basic shapes in Canvas",
      ],
      exercises: ["Draw rectangle, circle, line using Canvas and SVG"],
    },
    {
      day: "Day 11",
      topics: [
        "HTML Layout & Styling: Div, Span, Classes & IDs",
        "Inline, Block, Inline-block",
        "CSS Basics: Colors, Backgrounds, Fonts",
        "Favicon & Responsive HTML",
      ],
      exercises: ["Design a simple webpage layout using div and CSS classes"],
    },
    {
      day: "Day 12",
      topics: [
        "Advanced HTML: Web APIs, Geolocation, Web Storage, Web Workers, SSE",
        "HTML JavaScript Integration",
        "URL Encoding, Entities, Symbols, Emojis, Comments",
        "HTML Semantics",
      ],
      exercises: ["Use localStorage to store data", "Add emoji icons to your page", "Use semantic HTML tags correctly"],
    },
    {
      day: "Day 13",
      topics: [
        "HTML Exercises: Quizzes, Code Corrections, Website Examples",
        "HTML Best Practices, Accessibility, Performance, Internationalization",
      ],
      exercises: ["Build a small HTML project combining all learned topics"],
    },
  ];

  return (
    <div className="studyplan-container">
      <h1>HTML Comprehensive Study Plan</h1>

      {/* Flowchart */}
      <div className="flowchart-container">
        <h2>Learning Flow</h2>
        <div className="flowchart">
          <div className="flow-node">Basics of HTML</div>
          <div className="arrow">↓</div>
          <div className="flow-node">Text & Links</div>
          <div className="arrow">↓</div>
          <div className="flow-node">Images & Multimedia</div>
          <div className="arrow">↓</div>
          <div className="flow-node">Forms & Tables</div>
          <div className="arrow">↓</div>
          <div className="flow-node">Layout & Styling</div>
          <div className="arrow">↓</div>
          <div className="flow-node">Advanced HTML & APIs</div>
          <div className="arrow">↓</div>
          <div className="flow-node">Project & Exercises</div>
        </div>
      </div>

      {plan.map((dayPlan, idx) => (
        <div key={idx} className="day-plan">
          <h2>{dayPlan.day}</h2>
          <h3>Topics:</h3>
          <ul>
            {dayPlan.topics.map((topic, tid) => (
              <li key={tid}>{topic}</li>
            ))}
          </ul>
          <h3>Exercises:</h3>
          <ul>
            {dayPlan.exercises.map((ex, eid) => (
              <li key={eid}>{ex}</li>
            ))}
          </ul>
          <hr className="divider" />
        </div>
      ))}
    </div>
  );
};

export default HTML_StudyPlan;
